@if (notification) {
  <div class="stock-take-notification">
    @if (!notification.success && isIqVersionNotSupported) {
      <div class="stock-take-notification-guidance" role="status">
        <app-display-icon
          [border]="false"
          [colour]="iconColourEnum.yellow"
          [icon]="icons.infoSlabCircleOutline">
        </app-display-icon>
        <p>{{ iqNotSupportedSummary }}</p>
      </div>
    }
    @if (notification.response && !notification.success) {
      <div class="stock-take-notification-row stock-take-notification-row--actions">
        <span class="stock-take-notification-label">Result</span>
        <app-shared-button [colour]="'primary'" [fill]="true" (buttonClicked)="onViewMessage()">
          View message
        </app-shared-button>
      </div>
    }
    @if (canRetryProcessing) {
      <div class="stock-take-notification-row stock-take-notification-row--actions">
        <span class="stock-take-notification-label">Actions</span>
        <div class="stock-take-notification-actions">
          @if (canRetryWithoutFailedItems) {
            <app-shared-button [colour]="'primary'" [fill]="true" (buttonClicked)="onRetryWithoutFailedItems()">
              Retry without failed items
            </app-shared-button>
          } @else {
            <app-shared-button [colour]="'primary'" [fill]="true" (buttonClicked)="onRetryProcessing()">
              Retry processing
            </app-shared-button>
          }
        </div>
      </div>
    } @else if (!notification.success && notification.event && notification.retried) {
      <div class="stock-take-notification-row">
        <span class="stock-take-notification-label">Actions</span>
        <span class="stock-take-notification-value">Processing retry already submitted</span>
      </div>
    }
  </div>
}
